import React from "react";
import {
  Article,
  Section,
  SectionHeader,
  SectionTitle,
} from "../../styles/ResumeStyles";

const Projects = () => {
  return (
    <Article>
      <SectionTitle>Projects</SectionTitle>
      <Section>
        <SectionHeader>
          <p className="bold">Jify Admin Dashboard</p>
          <p>Apr 2022 - Now</p>
        </SectionHeader>
        <div>
          <em>( React, Ant design, Redux toolkit, typescript, AWS )</em>
          <ul>
            <li>
              Collaborated with the product team and end-users to build and
              update 20+ features
            </li>
            <li>
              Designed and built a KYC dashboard for reviewing and approving KYC
              requests
            </li>
            <li>
              Led the migration of user auth from Firebase to AWS Cognito and
              integrated auth flow for Role Based Access Control
            </li>
            <li>
              Built a custom component library for reusable components and
              collaborated with a design agency to revamp dashboard UI/UX
            </li>
            <li>
              Optimized database queries for performance and refactored existing
              components for readability, scalability, and performance
            </li>
            <li>
              Leveraged AWS services including DynamoDB, API Gateway, AWS
              Lambda, Cognito, S3, and SES
            </li>
          </ul>
        </div>
      </Section>

      <Section>
        <SectionHeader>
          <p className="bold">
            <a href="https://f1-info.onrender.com" target="_blank">
              Formula 1 info
              <span className="external_link">
                <img
                  src="/images/square-arrow-up-right-solid.svg"
                  alt="external_link"
                  width="12"
                />
              </span>
            </a>
          </p>
          <p>Mar 2022</p>
        </SectionHeader>
        <div>
          <em>
            ( React, styled-components, MongoDB, mongoose, express, NodeJS )
          </em>
          <ul>
            <li>
              Designed and built an F1 web application using React and Express,
              ensuring app responsiveness with styled components for React
            </li>
            <li>
              Built a custom component library for reusable components and
              optimized for performance and cost with a custom pipeline for data
            </li>
            <li>
              Implemented BEM for naming and styling to maximize code
              readability and maintenance
            </li>
          </ul>
        </div>
      </Section>

      <Section>
        <SectionHeader>
          <p className="bold">
            <a href="https://eshop-c776.onrender.com" target="_blank">
              e-shop
              <span className="external_link">
                <img
                  src="/images/square-arrow-up-right-solid.svg"
                  alt="external_link"
                  width="12"
                />
              </span>
            </a>
          </p>
          <p>Feb 2022</p>
        </SectionHeader>

        <div>
          <em>
            ( React, Redux, React-Bootstrap, MongoDB, mongoose, express, NodeJS
            )
          </em>
          <ul>
            <li>
              Developed an e-commerce website with cart, PayPal checkout,
              user-login, review, and admin functionality
            </li>
            <li>
              Built a responsive web app using React Bootstrap and implemented
              custom authentication for user login
            </li>
            <li>Integrated Redux for global state management.</li>
          </ul>
        </div>
      </Section>
    </Article>
  );
};

export default Projects;
